module.exports = __webpack_public_path__ + "img/demain-le-sport.3c34e9e6.jpg";